import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import Spinner from 'components/Spinner/view/desktop';

import FilterBlock from './FilterBlock';
import Table from './Table/Table';
import TableProviders from './TableProviders/TableProviders';
import useGeneralModel from 'features/reports/model/useGeneralModel';

import './General.scss';

const b = block('general');

const General = ({ isMobile = false }) => {
  const { actionProcessing } = useSelector(state => state.reports, shallowEqual);
  const statisticProvider = useSelector(state => state.reports.statisticProvider, shallowEqual);

  const {
    handleFormSubmit,
    handleKeyDown,
    handleStructureChange,
    onChangeBeginDate,
    onChangeEndDate,
    onChangeActiveDay,
    handleSetWithDiff,
    onChangeDiffRange,
    onChangeFilterValue,
    onChangeEndDiffDate,
    onChangeBeginDiffDate,
    handleGetDiff,
    values,
  } = useGeneralModel();

  return (
    <div className={b({ isMobile })}>
      <Spinner isLoading={actionProcessing} />
      <FilterBlock
        handleFormSubmit={handleFormSubmit}
        handleKeyDown={handleKeyDown}
        handleStructureChange={handleStructureChange}
        onChangeFilterValue={onChangeFilterValue}
        onChangeBeginDate={onChangeBeginDate}
        onChangeEndDate={onChangeEndDate}
        onChangeActiveDay={onChangeActiveDay}
        values={values}
        isMobile={isMobile}
      />
      <Table
        handleSetWithDiff={handleSetWithDiff}
        withDiff={values.withDiff}
        onChangeDiffRange={onChangeDiffRange}
        onChangeBeginDiffDate={onChangeBeginDiffDate}
        onChangeEndDiffDate={onChangeEndDiffDate}
        values={values}
        handleGetDiff={handleGetDiff}
      />
      <TableProviders providers={statisticProvider.providers} />
    </div>
  );
};

export default General;
